import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { SuccessIcon as r } from "../../../assets/svgs/SuccessIcon.js";
import { ErrorIcon as e } from "../../../assets/svgs/ErrorIcon.js";
const m = ({ type: s }) => s === "success" || s === "removed" ? /* @__PURE__ */ c("div", { className: "applied-coupon-badge success-coupon", children: [
  /* @__PURE__ */ o("span", { children: /* @__PURE__ */ o(r, {}) }),
  s === "success" ? "Cupom aplicado com sucesso" : "Cupom removido com sucesso"
] }) : /* @__PURE__ */ c("div", { className: "applied-coupon-badge error-coupon", children: [
  /* @__PURE__ */ o("span", { children: /* @__PURE__ */ o(e, {}) }),
  "Não foi possível aplicar o cupom. Tente aplicar mais tarde."
] });
export {
  m as Alert
};
